import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '~/store';

const currentClanIdSelector = (state: RootState) => state.currentAccount?.clanId || null;

const clansItemsSelector = (state: RootState) => state.clans.items;

export const currentClanSelector = createSelector(
  [currentClanIdSelector, clansItemsSelector],
  (currentClanId, clanItems) => {
    return currentClanId ? clanItems[currentClanId] || null : null;
  },
);

export const clanRenameSelector = (state: RootState) => ({
  name: state.clanRename.name,
  tag: state.clanRename.tag,
  isProcessing: state.clanRename.isProcessing,
  error: state.clanRename.error,
});
